"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import styles from "./coming-soon.module.css";

export default function ComingSoon() {
  const t = useTranslations("ComingSoon");

  return (
    <main className={styles.main}>
      <Image
        className={styles.background}
        src="/coming-soon-hero.webp"
        alt=""
        fill
        priority
        unoptimized
        sizes="100vw"
      />
      <div className={styles.overlay} />
      <section className={styles.content} aria-labelledby="coming-soon-title">
        <p className={styles.eyebrow}>{t("eyebrow")}</p>
        <h1 id="coming-soon-title">{t("title")}</h1>
        <p className={styles.description}>{t("description")}</p>
        <span className={styles.rule} aria-hidden="true" />
      </section>
    </main>
  );
}
